<script>
  import PlayerAvatar from '@/components/Player/PlayerAvatar'
  import NavbarItemNotifications from './Notifications/List'

  export default {
    components: {
      PlayerAvatar,
      NavbarItemNotifications
    },

    data() {
      return {
        menu_open: false
      }
    },

    methods: {
      throwHit() {
        this.menu_open = false
        this.$store.commit('Modals/show', 'hit_post_bar')
        this.$trackEventBasic('POST HIT', 'click header button', window.location.pathname)
      }
    }
  }
</script>

<template>
  <header class="app-header">
    <nav class="navbar">
      <div class="navbar-brand">
        <router-link class="navbar-item" :to="{name: 'feed'}" @click.native="menu_open = false">
          <img src="../assets/img/logo_small.svg" alt="The Warmup">
        </router-link>
        <div class="navbar-burger" @click="menu_open = !menu_open">
          <a class="is-toggle navbar-item">
            <i class="fa fa-bars" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    
      <div class="navbar-end navbar-menu" :class="{'is-active': menu_open}">
        <router-link
          class="navbar-item"
          :class="{'is-active': $route.name == 'feed'}"
          :to="{name: 'feed'}"
          @click.native="menu_open = false">
          {{ $t('nav.home') }}
        </router-link>
        <router-link
          class="navbar-item"
          :to="{name: 'players'}"
          active-class="is-active"
          @click.native="menu_open = false">
          {{ $t('nav.players') }}
        </router-link>
        <!-- <router-link
          class="navbar-item"
          :to="{name: 'jobs'}"
          active-class="is-active"
          v-once>
          {{ $t('nav.jobs') }}
        </router-link>
        <router-link
          class="navbar-item"
          :to="{name: 'hall_of_fame'}"
          active-class="is-active"
          v-once>
          {{ $t('nav.hall_of_fame') }}
        </router-link> -->
    
        <navbar-item-notifications @click.native="menu_open = false"/>
    
        <div class="navbar-item">
          <router-link
            :to="{name: 'player', params: {id: user.player.slug}}"
            @click.native="menu_open = false">
            <player-avatar class="is-avatar" :player="user.player" size="42"/>
          </router-link>
        </div>

        <div class="navbar-item">
          <button class="button is-warning is-small"
            @click="throwHit()"
            v-once>
            {{ $t('buttons.throw_hit') }}
          </button>
        </div>
      </div>
    </nav>
  </header>
</template>



// WEBPACK FOOTER //
// PrivateHeader.vue?67472178